package de.oevbs.kunde.kundenportal2.services.tax

import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kosmos.ui.icons.icon
import de.oevbs.kosmos.ui.layouts.card
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.PortalContactNotes
import de.oevbs.kunde.kundenportal2.carContractsButtonToggleFormat
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.kunde.kundenportal2.navigation.visit
import dev.fritz2.core.RenderContext
import dev.fritz2.core.invoke
import dev.fritz2.core.tabIndex
import dev.fritz2.core.transition
import dev.fritz2.headless.components.popOver
import dev.fritz2.headless.foundation.utils.floatingui.core.middleware.offset
import dev.fritz2.headless.foundation.utils.floatingui.utils.PlacementValues
import dev.fritz2.headless.validation.Severity
import kotlinx.coroutines.flow.combine

fun RenderContext.taxStart() {
    val taxStore = TaxStore(job)
    headerImageLayout {
        title("Steuerbescheinigungen bestellen")
        content {
            renderSteps(taxStore)
        }
    }
}

private fun RenderContext.renderSteps(taxStore: TaxStore) {

    taxStore.currentStep.render { step ->

        GlobalServiceMessagesStore.clear()

        when (step) {
            GeneralProgressStep.SUBMIT1 -> taxStep1(taxStore)
            GeneralProgressStep.SUCCESS2 -> {
                val results = taxStore.taxResultStore.current
                if (results.failed.isNotEmpty()) {
                    messagePagePre(
                        header = "Teilweise angefordert.",
                        severity = Severity.Info,
                        preContent = PortalContactNotes.TaxRequestedAllContracts(
                            success = results.successful,
                            failure = results.failed,
                            year = taxStore.selectedYear.toString() //.current.toString() //Fixme: Jahre wieder einbauen
                        ).note
                    )
                } else {
                    messagePagePre(
                        header = "Erfolgreich angefordert!",
                        preContent = PortalContactNotes.TaxRequestedAllContractsSuccessful(
                            success = results.successful,
                            year = taxStore.selectedYear.toString() //.current.toString() //Fixme: Jahre wieder einbauen
                        ).note
                    )
                }
            }
        }
    }
}

fun RenderContext.taxStep1(taxStore: TaxStore) {
    contentContainer {
        taxStore.init()
        globalInitTracker.data.combine(taxStore.initFailedFlow, ::Pair).render { (loading, failed) ->
            if (loading) return@render
            when {
                failed -> noContractDataFoundMessage()
                else -> showUi(taxStore)
            }
        }
    }
}

fun RenderContext.showUi(taxStore: TaxStore) {

    paragraph {
        +"Wenn Sie für Ihre Steuererklärung eine Bescheinigung über den gezahlten Beitrag zu Ihren Versicherungen brauchen,"
        b { +" nutzen Sie einfach Ihre jährliche Beitragsrechnung oder Ihren Versicherungsschein als Nachweis." }
        +" Diese Dokumente finden Sie in Ihrem "
        textualButton("Posteingang ") handledBy { Pages.inboxInbox.visit() }
        +"."
    }

    paragraph {
        //Fixme: Jahre wieder einbauen
        +"Bei Kfz-Verträgen haben Sie hier zusätzlich die Möglichkeit, für das letzte Kalenderjahr eine Bescheinigung für das Finanzamt anzufordern."
        +" Wir senden Ihnen die Bescheinigung auf Ihrem "
        textualButton("bevorzugten Versandweg") handledBy { Pages.inboxDelivery.visit() }
        +" zu. Sollte Ihr Vertrag mittlerweile beendet sein, senden Sie uns eine Mail an "
        inlineLink(
            text = "service@oeffentliche.de",
            link = "mailto:service@oeffentliche.de",
        )
        +"."
    }

//    sectionHeader("Wählen Sie ein Jahr aus:") //Fixme: Jahre wieder einbauen, wenn Holger das Backend angepasst hat
//    card {
//        buttonToggleKupo<Int> {
//            value.single(taxStore.selectedYear)
//            options = taxStore.yearsToContractsStore.current.keys.toList()
//        }
//    }
//    br {}

    taxStore.yearsToContractsStore.data //.combine(taxStore.selectedYear.data) { a, y -> a to y } //Fixme: Jahre wieder einbauen
        .render { allYears -> //(allYears, selectedYear) ->

            // Es können immer nur Bescheinungen für 1 Jahr angefordert werden, dh. bei Änderung des Jahres wird die Liste geleert
            taxStore.selectedContracts.update(emptyList())

            val selectedYear = taxStore.selectedYear

            if (allYears.isEmpty() || selectedYear == 0) {
                card {
                    paragraph { +"Es wurden keine aktiven Verträge im letzten Jahr gefunden, für die eine Bescheinigung via Kundenportal angefordert werden kann." }
                }
                return@render
            }

            val validContracts = allYears[selectedYear]?.contracts ?: emptyList()
            val invalidContractsCount = allYears[selectedYear]?.invalidContractsCount ?: 0

            if (validContracts.isEmpty()) {
                card {
                    paragraph { +"Es wurden keine aktiven Verträge im letzten Jahr gefunden, für die eine Bescheinigung via Kundenportal angefordert werden kann." }
                    if (invalidContractsCount != 0) paragraph { helpPopoverCarContractsMissing(invalidContractsCount) }
                }
                return@render
            }

            sectionHeader("Vertrag auswählen (Mehrfachauswahl möglich)") {
                if (invalidContractsCount != 0) helpPopoverCarContractsMissing(invalidContractsCount)
            }

            div("flex flex-col gap-y-3") {
                card {
                    buttonToggleKupo<CarContract> {
                        value.multi(taxStore.selectedContracts)
                        options = validContracts
                        optionsFormat = carContractsButtonToggleFormat
                    }
                }

                div {
                    +"Sie haben "
                    span {
                        taxStore.selectedContracts.data.render(into = this) {
                            if (it.isNotEmpty()) +it.size.toString()
                            else +"noch keine"
                        }
                    }
                    +" Bescheinigung(en) für $selectedYear ausgewählt."
                }

                buttonContainer {
                    btn {
                        disabled(taxStore.selectedContracts.data.combine(globalSubmitTracker.data) { list, busy ->
                            (list.isEmpty() || busy)
                        })
                        label("Jetzt anfordern")
                        //label(taxStore.selectedYear.data.map { "Jetzt für $it anfordern" }) //Fixme: Jahre wieder einbauen
                        busy(globalSubmitTracker.data)
                    }.clicks handledBy taxStore.requestTax
                }
            }
        }
}

fun RenderContext.helpPopoverCarContractsMissing(countMissing: Int) {
    popOver {
        popOverButton {
            tabIndex(-1)
            div("flex flex-row items-center gap-1") {
                span("text-sm text-primary-500 whitespace-nowrap") { +"Warum sehe ich nicht alle Verträge?" }
                icon("h-5 w-5 text-primary-500", icon = MaterialIconsOutlined.help)
            }
            popOverPanel("bg-primary-50 shadow rounded p-3 py-4 max-w-full md:max-w-96 z-10") {
                placement = PlacementValues.bottomEnd
                addMiddleware(offset {
                    mainAxis = 12
                    crossAxis = 0
                })
                transition(
                    opened,
                    "transition ease-out duration-200",
                    "opacity-0 translate-y-1",
                    "opacity-100 translate-y-0",
                    "transition ease-in duration-150",
                    "opacity-100 translate-y-0",
                    "opacity-0 translate-y-1"
                )
                arrow("h-6 w-6")
                paragraph("text-sm") {
                    contractsMissingMessage(countMissing)
                }
            }
        }
    }
}

fun RenderContext.contractsMissingMessage(countMissing: Int) {
    span {
        +"Für dieses Kalenderjahr können $countMissing Bescheinigungen nicht im Kundenportal angefordert werden."
        br {}
        br {}
        +"Manche Verträge sind von der Online-Anforderung ausgeschlossen, weil"
        +" beispielsweise eine Vertragsanpassung in dem betreffenden Kalenderjahr vorgenommen wurde,"
        +" das Hauptfälligkeitsdatum nicht der 1. Januar ist oder ein Vertragsteil 'Unfall' enthalten ist."
        +" In diesen Fällen hilft Ihnen unser Kundenservice gerne weiter - rufen Sie uns an."
    }
}